import { useGLTF } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import React, { useRef, useState } from "react";
import { PointLight } from "three";
import { useFrame } from "@react-three/fiber";
import { stageObject } from "../../interface";
import { HoverText } from "../../HoverText";

export const Commander = ({
  url,
  scale,
  position,
  getCharacters,
}: stageObject) => {
  const { scene } = useGLTF(url, "/draco/");
  const commanderRef = useRef<any>();
  const textRef = useRef<any>();
  const pointLightRef = useRef<PointLight>(null!);
  const [hovered, setHovered] = useState(false);
  const speed = 0.01; // 初始旋转速度

  // 鼠标移入时显示光源和文本
  const handlePointerOver = () => {
    setHovered(true);
    if (pointLightRef.current) {
      pointLightRef.current.visible = true;
    }
    if (textRef.current) {
      textRef.current.visible = true;
    }
  };

  // 鼠标移出时隐藏光源和文本
  const handlePointerOut = () => {
    setHovered(false);
    if (pointLightRef.current) {
      pointLightRef.current.visible = false;
    }
    if (textRef.current && !isMobile) {
      textRef.current.visible = false;
    }
  };

  let rotationY = Math.random() < 0.5;
  useFrame(() => {
    if (commanderRef.current) {
      if (!hovered) {
        if (rotationY) {
          commanderRef.current.rotation.y += speed;
        } else {
          commanderRef.current.rotation.y -= speed;
        }
      }
      const { x, y, z } = commanderRef.current.position;

      if (pointLightRef.current) {
        pointLightRef.current.position.set(x, y - 0.9, z + 0.1);
      }

      if (textRef.current) {
        if (isMobile) {
          textRef.current.visible = true;
          textRef.current.fontSize = "0.2";
          textRef.current.position.set(x, y + 0.65, z - 0.1);
        } else {
          textRef.current.position.set(x + 1, y + 0.1, z - 0.1);
        }
      }
    }
  });

  return (
    <>
      <primitive
        ref={commanderRef}
        object={scene}
        position={position}
        rotation={[0, 0, 0]}
        scale={scale}
        onClick={() => getCharacters("commander")}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />
      <pointLight
        visible={isMobile}
        ref={pointLightRef}
        intensity={2}
        color={"#800080"}
      />
      <HoverText text={"Pulsar"} color={"#800080"} textRef={textRef} />
    </>
  );
};
